import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';

// Actions
export const FETCH_DEFAULT_REPORT_STRUCTURE = 'FETCH_DEFAULT_REPORT_STRUCTURE';
export const FETCH_DEFAULT_REPORT_STRUCTURE_SUCCESS = 'FETCH_DEFAULT_REPORT_STRUCTURE_SUCCESS';
export const FETCH_DEFAULT_REPORT_STRUCTURE_FAIL = 'FETCH_DEFAULT_REPORT_STRUCTURE_FAIL';
export const CLEAR_DEFAULT_REPORT_STRUCTURE = 'CLEAR_DEFAULT_REPORT_STRUCTURE';

// Reducer
export default function defaultReportStructureReducer(state = {
  data: [], loading: 0,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_DEFAULT_REPORT_STRUCTURE:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_DEFAULT_REPORT_STRUCTURE_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_DEFAULT_REPORT_STRUCTURE_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_DEFAULT_REPORT_STRUCTURE:
      return {
        ...state,
        data: [],
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchDefaultReportStructure(payload) {
  return { type: FETCH_DEFAULT_REPORT_STRUCTURE, payload };
}

export function fetchDefaultReportStructureSuccess(payload) {
  return { type: FETCH_DEFAULT_REPORT_STRUCTURE_SUCCESS, payload };
}

export function fetchDefaultReportStructureFail(payload) {
  return { type: FETCH_DEFAULT_REPORT_STRUCTURE_FAIL, payload };
}

export function clearDefaultReportStructure(payload) {
  return { type: CLEAR_DEFAULT_REPORT_STRUCTURE, payload };
}

// Requests
export function requestFetchDefaultReportStructure(payload) {
  return callApi('/report/default_report_structure/?Report Type=Order');
}

// Sagas
function* fetchDefaultReportStructureSaga(action) {
  const { triggerLoading, filters } = action.payload;
  try {
    const res = yield call(requestFetchDefaultReportStructure, action.payload);
    yield put(fetchDefaultReportStructureSuccess({
      data: res.data,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchDefaultReportStructureFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

export function* defaultReportStructureSaga() {
  yield takeLatest(FETCH_DEFAULT_REPORT_STRUCTURE, fetchDefaultReportStructureSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/defaultReportStructure.js